import { useEffect, useState } from 'react';
import {
  fetchOperators,
  updateOperatorName,
  refranchiseOperator,
} from '../services/operator.api';

export function useOperators() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const loadOperators = async (signal) => {
    try {
      setRefreshing(true);
      const list = await fetchOperators(signal);
      const mapped = Array.isArray(list)
        ? list.map((op) => ({
            name: op.Description,
            description: op.Code,
            unitCount: op.UnitCount,
            meterCount: op.MeterCount,
            evnCount: op.EVNCount,
            errorsCount: op.ErrorsCount || 0,
          }))
        : [];
      setRows(mapped);
    } catch {
      setRows([]);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  useEffect(() => {
    const ac = new AbortController();
    loadOperators(ac.signal);
    return () => ac.abort();
  }, []);

  const modifyOperator = async (code, newName) => {
    await updateOperatorName(code, newName);
    await loadOperators(); 
  };

  const refranchise = async (payload) => {
    await refranchiseOperator(payload);
    await loadOperators(); 
  };

  return {
    rows,
    setRows,
    loading,
    refreshing,
    refresh: () => loadOperators(),
    modifyOperator,
    refranchise,
  };
}
